import React, { useEffect, useState } from "react";
import api from "../api";

function Card({ children, className = "" }) {
  return <div className={`rounded-2xl border border-slate-200 bg-white p-5 shadow-sm ${className}`}>{children}</div>;
}

export default function AuditLog() {
  const [rows, setRows] = useState([]);
  useEffect(() => { api.get("/admin/audit-logs").then((r) => setRows(r.data)).catch(() => {}); }, []);
  const fmt = (v) => (v == null ? "" : typeof v === "object" ? JSON.stringify(v) : String(v));
  return (
    <div className="space-y-4" data-testid="audit-log">
      <Card>
        <h2 className="text-base font-bold text-slate-900">Audit Log</h2>
        <p className="text-sm text-slate-500">Sensitive actions across the portal — role changes, assignments, pay changes, program approvals, Patriot and workforce status updates.</p>
      </Card>
      <Card>
        <div className="overflow-x-auto">
          <table className="w-full text-left text-sm">
            <thead className="text-xs uppercase tracking-wide text-slate-400">
              <tr><th className="py-2 pr-4">When</th><th className="py-2 pr-4">Actor</th><th className="py-2 pr-4">Action</th><th className="py-2 pr-4">Target</th><th className="py-2 pr-4">Change</th></tr>
            </thead>
            <tbody>
              {rows.length === 0 && <tr><td colSpan={5} className="py-8 text-center text-slate-400">No audit entries yet.</td></tr>}
              {rows.map((r) => (
                <tr key={r.id} className="border-b border-slate-50" data-testid={`audit-${r.id}`}>
                  <td className="py-2 pr-4 text-slate-500">{new Date(r.at).toLocaleString()}</td>
                  <td className="py-2 pr-4 text-slate-700">{r.actor_name}</td>
                  <td className="py-2 pr-4"><span className="rounded-full bg-violet-50 px-2 py-0.5 text-xs font-semibold text-violet-700">{r.action}</span></td>
                  <td className="py-2 pr-4 text-slate-500 max-w-[120px] truncate" title={r.target}>{r.target}</td>
                  <td className="py-2 pr-4 text-xs text-slate-500">{fmt(r.prev)} {r.prev && r.new ? "→" : ""} {fmt(r.new)} {r.notes ? `(${r.notes})` : ""}</td>
                </tr>
              ))}
            </tbody>
          </table>
        </div>
      </Card>
    </div>
  );
}
